export default "__VITE_ASSET__Dbu1251W__"